import Presenter from 'microcosm/addons/presenter'
import Strategies from '../../components/strategies/aggregate'

import {
  currentAggregates,
  activeAggregate,
  highlight,
  byRegion
} from '../../queries'

class StrategiesAggregatePresenter extends Presenter {
  view = Strategies

  setup(repo) {
    repo.index(
      'series',
      'strategies,ui.focused,ui.region',
      byRegion('strategies')
    )
  }

  getModel({ location }) {
    const { query } = location

    return {
      query: query,
      region: state => state.ui.region,
      series: this.repo.memo('series', currentAggregates(query)),
      aggregate: this.repo.memo('series', highlight(query)),
      activeAggregate: this.repo.memo('series', activeAggregate(query))
    }
  }
}

export default StrategiesAggregatePresenter



// WEBPACK FOOTER //
// ./src/presenters/strategies/aggregate.js